import { gql } from "lib/apolloClient";
import { additionalDetailsUserFragment } from "./StudentFragments";

export const removeChildForFamilyMemberMutation = gql`
  mutation removeChildForFamilyMember($studentId: ID!, $parentId: ID) {
    platform {
      removeChildForFamilyMember(studentId: $studentId, parentId: $parentId)
    }
  }
`;

export const unenrolStudentMutation = gql`
  mutation unenrollStudent($id: ID!, $academicYearId: ID!) {
    platform {
      unenrollStudent(input: { id: $id, academicYearId: $academicYearId })
    }
  }
`;

export const blockUnblockStudentMutation = gql`
  mutation blockUnblockStudent($input: UserUpdateInput!) {
    platform {
      updateUserV2(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const bulkStudentBlockUnblockMutation = gql`
  mutation bulkStudentBlockUnblock($input: BulkStudentBlockUnblockInput!) {
    platform {
      bulkStudentBlockUnblock(input: $input) {
        isSuccess
        ids
        updatedUsersCount
      }
    }
  }
`;

export const bulkPortfolioDownloadMutation = gql`
  mutation bulkGenerateStudentPortfolio(
    $input: BulkGenerateStudentPortfolioInput!
  ) {
    documentation {
      bulkGenerateStudentPortfolio(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const addUserMutation = gql`
  mutation addUserV2(
    $email: String
    $userType: USER_TYPE_ENUM!
    $courses: [ID!]
    $classLevelsMap: [ClassLevelMapInput!]
    $firstName: String
    $middleName: String
    $lastName: String
    $pronouns: String
    $preferredName: String
    $prefix: String
    $suffix: String
    $profileImage: String
    $designation: ID
    $sourceId: String
    $curriculumProgramId: ID
    $curriculumProgramIds: [ID!]
    $snpEvaluationCycles: [ID!]
    $tags: [ID!]
    $yearGroupId: ID
    $registrationCategory: REGISTRATION_CATEGORY_TYPE_ENUM
    $courseTagMap: [CourseTagMapInput!]
    $staffRelationMap: [StaffRelationMapInput!]
    $gender: String
    $otherDetails: OtherUserDetailsInput
    $mergeUserWithSameEmail: Boolean
    $allCourseMap: AllCourseMapInput
    $displayRole: String
    $academicYearId: ID
    $aclUserRoles: ACLUserRolesInput
    $curriculumAcademicYearMap: [CurriculumAcademicYearMapInput!]
    $enrollmentDate: String
  ) {
    platform {
      addUserV2(
        input: {
          email: $email
          userType: $userType
          courses: $courses
          firstName: $firstName
          middleName: $middleName
          lastName: $lastName
          pronouns: $pronouns
          preferredName: $preferredName
          prefix: $prefix
          suffix: $suffix
          profileImage: $profileImage
          designation: $designation
          sourceId: $sourceId
          curriculumProgramId: $curriculumProgramId
          snpEvaluationCycles: $snpEvaluationCycles
          tags: $tags
          yearGroupId: $yearGroupId
          registrationCategory: $registrationCategory
          courseTagMap: $courseTagMap
          staffRelationMap: $staffRelationMap
          gender: $gender
          otherDetails: $otherDetails
          mergeUserWithSameEmail: $mergeUserWithSameEmail
          allCourseMap: $allCourseMap
          displayRole: $displayRole
          academicYearId: $academicYearId
          curriculumProgramIds: $curriculumProgramIds
          aclUserRoles: $aclUserRoles
          curriculumAcademicYearMap: $curriculumAcademicYearMap
          classLevelsMap: $classLevelsMap
          enrollmentDate: $enrollmentDate
        }
      ) {
        isSuccess
        warning
        user {
          ...userItem
        }
      }
    }
  }
  ${additionalDetailsUserFragment.user}
`;

export const editUserMutation = gql`
  mutation editUser(
    $firstName: String
    $middleName: String
    $lastName: String
    $pronouns: String
    $preferredName: String
    $prefix: String
    $suffix: String
    $id: ID!
    $email: String
    $profileImage: String
    $sourceId: String
    $isArchived: Boolean
    $registrationCategory: REGISTRATION_CATEGORY_TYPE_ENUM
    $yearGroupId: ID
    $addedCourses: [ID!]
    $removedCourses: [ID!]
    $courseTagMap: [CourseTagMapInput!]
    $otherDetails: OtherUserDetailsInput
    $gender: String
    $staffRelationMap: [StaffRelationMapInput!]
    $academicYearId: ID
    $isBlocked: Boolean
    $removedClassLevelsMap: [ClassLevelMapInput!]
    $addedClassLevelsMap: [ClassLevelMapInput!]
    $enrollmentDate: String
  ) {
    platform {
      updateUserV2(
        input: {
          id: $id
          firstName: $firstName
          middleName: $middleName
          lastName: $lastName
          pronouns: $pronouns
          preferredName: $preferredName
          prefix: $prefix
          suffix: $suffix
          profileImage: $profileImage
          email: $email
          sourceId: $sourceId
          isArchived: $isArchived
          isBlocked: $isBlocked
          registrationCategory: $registrationCategory
          yearGroupId: $yearGroupId
          addedCourses: $addedCourses
          removedCourses: $removedCourses
          courseTagMap: $courseTagMap
          otherDetails: $otherDetails
          gender: $gender
          staffRelationMap: $staffRelationMap
          academicYearId: $academicYearId
          removedClassLevelsMap: $removedClassLevelsMap
          addedClassLevelsMap: $addedClassLevelsMap
          enrollmentDate: $enrollmentDate
        }
      ) {
        warning
        isSuccess
        user {
          ...userItem
        }
      }
    }
  }
  ${additionalDetailsUserFragment.user}
`;

export const confirmBulkUploadDetailsMutation = gql`
  mutation confirmBulkUploadDetails($input: EntityBulkActionDeciderInput!) {
    platform {
      entityBulkActionDecider(input: $input)
    }
  }
`;
